<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {

    data: function() {
        return {
            ...BaseForm.data(),
            selected_communities: '',
            picker_state: {
                disabled: {}
            },
            persistents: {
                selected_metros: [],
                selected_regions: [],
                selected_communities: [],
                selected_residences: [],
                selected_homes: [],
            }
        }
    },

    props: [
        'openModal',
        'closeModal',
        'isModalOpen',
        'residenceId',
        'homeId',
        'communityId',
        'regionId',
        'metroId',
        'metroOptions',
    ],

    mounted() {
        if (this.metroId) {
            this.persistents.selected_metros = [this.metroId];
        }
        if (this.regionId) {
            this.persistents.selected_regions = [this.regionId];
        }
        if (this.communityId) {
            this.persistents.selected_communities = [this.communityId];
        }
        if (this.residenceId) {
            this.persistents.selected_residences = [this.residenceId];
        }
        if (this.homeId) {
            this.persistents.selected_homes = [this.homeId];
        }

        this.boot();
    },

    computed: {
        ...BaseForm.computed,
        ...mapGetters({
            modalData: 'modal/getData'
        })
    },

    watch: {
        ...BaseForm.watchers,
        'selected_communities': function(val) {
            if (val) {
                this.persistents.selected_communities = [val];
            }

            const metro = this.metroOptions.find(metro => metro.regions.some(region => region.communities.some(community => community.id == val)));
            const region = metro ? metro.regions.find(region => region.communities.some(community => community.id == val)) : null;

            this.persistents.selected_metros = metro ? [metro.id] : [];
            this.persistents.selected_regions = region ? [region.id] : [];
        }
    },

    created() {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        this.picker_state.disabled = {to: yesterday};

        if (this.modalData.metroId) {
            this.persistents['selected_metros'] = [this.modalData.metroId];
        }
        if (this.modalData.regionId) {
            this.persistents['selected_regions'] = [this.modalData.regionId];
        }
        if (this.modalData.communityId) {
            this.persistents['selected_communities'] = [this.modalData.communityId];
        }
        if (this.modalData.homeId) {
            this.persistents['selected_homes'] = [this.modalData.homeId];
        }
    },

    methods: {
        ...BaseForm.methods,

        submit(event) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.beforeSubmit().then((token) => {
                        this.form.post(event.target.action, {
                                ...this.fields, ...this.persistents,
                                'g-recaptcha-response': token
                            })
                            .then((result) => this.success(result, event))
                                .catch(() => this.failure());
                        });
                }
            });
        }
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/forms/schedule-tour-form.vue